/**
 * Zips two arrays, result is shrank to the length of the shortest array.
 */
export function zip<T, S>(a: T[], b: S[]): Array<[T, S]> {
  const minLength = Math.min(a.length, b.length);
  return a.slice(0, minLength).map((el, idx) => [el, b[idx]]);
}
